/**
 * Register the network-only service worker (production builds only).
 * Returns the registration promise, or null when skipped.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined') return null
  if (!('serviceWorker' in navigator)) return null
  // Avoid SW interference with Vite HMR / local module graph.
  if (!import.meta.env.PROD) return null

  return navigator.serviceWorker
    .register('/sw.js', { scope: '/' })
    .catch((err) => {
      console.warn('[sw] registration failed', err)
      return null
    })
}
